import React from 'react';

const FlashWarning = () => (
    <div>
        <h2 style={{ color: 'black' }}>Insufficient Flash Player Requirements</h2>
        <div className="clr" />
        <div>
            <p>Click below to download the latest version of Flash</p>
            <p>
                <a target="_blank" rel="noopener noreferrer" href="http://get.adobe.com/flashplayer/">
                    <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', paddingTop: '10px' }} alt="Get Adobe Flash Player" src="http://a.espncdn.com/espn3/images/watchespn/get_adobe_flash_player.png" />
                </a>
            </p>
        </div>
    </div>
);

export default FlashWarning;



// WEBPACK FOOTER //
// ./app/modal/messaging/FlashWarning.js